import React from "react";
import { Box, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { Email, ErrorOutline, Mail } from "@mui/icons-material";

import { IAcitvityEmailConversationLogsProps } from "./Activity.types";
import { LoadState } from "../../constants/enums";
import { useDispatchWrapper } from "../../hooks";
import { useSelector } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";
import { fetchEmailConversationListAsync } from "../../redux/activity/activityActions";
import { IEmailConversationActivity } from "../../redux/activity/activity.types";
import { AcitivtyEmailConversationDialog } from "./ActivityEmailConversationDialog";
import { useTimezoneFormatter } from "../../hooks/useTimezoneFormatter";

export const ActivityEmailConversationLogs: React.FC<
  IAcitvityEmailConversationLogsProps
> = (props) => {
  const { moduleInformation } = props;
  const { list, loading, error } = useSelector(
    (storeState: IStoreState) => storeState.acitivty.emailConversation,
  );

  const theme = useTheme();
  const dispatch = useDispatchWrapper();

  const fetchLogs = async () => {
    dispatch(fetchEmailConversationListAsync(moduleInformation.moduleId));
  };

  React.useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <>
      <Stack mt={3}>
        <Stack
          padding={1}
          sx={{
            backgroundColor: theme.palette.grey[200],
            borderRadius: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Mail color="success" />
          <Typography variant="h5" fontWeight={600}>
            Email Conversation
          </Typography>
        </Stack>
        <Stack direction={"column"} spacing={1} mt={3}>
          {loading === LoadState.InProgress && (
            <>
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
              <Skeleton height={"30px"} />
            </>
          )}
          {loading === LoadState.Failed && error && (
            <>
              <Box
                minHeight={100}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Box display={"flex"} justifyContent={"center"} mb={1}>
                  <ErrorOutline />
                </Box>
                <Box display={"flex"} justifyContent={"center"} width={"80%"}>
                  <Typography
                    variant="body1"
                    textAlign={"center"}
                    fontWeight={600}
                  >
                    {error}
                  </Typography>
                </Box>
              </Box>
            </>
          )}

          {list.map((item, index) => {
            return <Row key={index} data={item} />;
          })}
        </Stack>
      </Stack>
    </>
  );
};

const Row: React.FC<{ data: IEmailConversationActivity }> = ({ data }) => {
  const theme = useTheme();
  const { ftDateTime } = useTimezoneFormatter();
  const [openView, setOpenView] = React.useState(false);

  const handleToggle = () => {
    setOpenView(!openView);
  };

  return (
    <>
      <Stack position={"relative"} minHeight={"80px"} onClick={handleToggle}>
        <Stack
          direction={"row"}
          spacing={1.5}
          sx={{
            ":before": {
              content: "''",
              height: "100%",
              width: "2px",
              position: "absolute",
              left: "4%",
              top: 0,
              bottom: 0,
              zIndex: 0,
              backgroundColor: theme.palette.info.main,
            },
          }}
        >
          <Box
            border={"1px solid #fff"}
            sx={{ backgroundColor: "#fff" }}
            zIndex={1}
            height={"fit-content"}
          >
            <Email color="info" fontSize="large" />
          </Box>
          <Stack width={"100%"}>
            <Stack
              direction={"row"}
              flexWrap={"wrap"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography
                variant="body1"
                fontSize={"1.1rem"}
                color={"primary"}
                maxWidth={"55%"}
                textOverflow={"ellipsis"}
                overflow={"hidden"}
                whiteSpace={"nowrap"}
                fontWeight={600}
              >
                {data.subject}
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {ftDateTime(data.insert_ts)}
              </Typography>
            </Stack>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography variant="body1" fontWeight={500}>
                <span
                  dangerouslySetInnerHTML={{ __html: data.body.content || "" }}
                ></span>
              </Typography>
            </Stack>
            {/* <Typography variant="body1" fontWeight={500}>
            Created By : <span style={{marginLeft: 2}}>{task.craeted_by_name}</span>
          </Typography> */}
          </Stack>
        </Stack>
      </Stack>
      {openView && (
        <AcitivtyEmailConversationDialog
          open={openView}
          data={data}
          onClose={handleToggle}
        />
      )}
    </>
  );
};
